<template>
    <div
        class="accordion-panel"
        :class="[`accordion-panel--${props.type}`, 'bg-stone-200']"
        :id="props.id"
    >
        <div
            v-if="!props.type"
            class="accordion-panel__header display-flex align-items-center justify-between p-md"
            :class="{ 'accordion-panel__header--active': active }"
            @click="toggleBellows()"
        >
            <p class="accordion-panel__title pt-xxs bold">{{ props.label }}</p>
            <font-awesome-icon
                class="accordion-panel__icon"
                icon="fa-solid fa-chevron-down"
                size="lg"
            />
        </div>
        <div
            v-else
            class="accordion-panel__header accordion-panel__header--with-icon display-flex align-items-center justify-between py-sm px-lg"
            :class="{ 'accordion-panel__header--active': active }"
            @click="toggleBellows()"
        >
            <div class="accordion-panel__label-group display-flex align-items-center">
                <font-awesome-icon
                    class="accordion-panel__feature-icon text-gold mr-md"
                    icon="fa-solid fa-sparkles"
                    size="lg"
                />
                <p class="accordion-panel__title pt-xs text-stone-700">
                    {{ props.label }}
                </p>
            </div>
            <font-awesome-icon
                class="accordion-panel__icon text-accent"
                icon="fa-solid fa-chevron-down"
            />
        </div>
        <div
            class="accordion-panel__content px-lg mt-n4 pb-lg"
            :class="{ 'accordion-panel__content--active': active }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    id: {
        type: String,
        default: '',
    },
    initiallyExpanded: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: '',
    },
})

const active = ref(props.initiallyExpanded)

const toggleBellows = () => {
    active.value = !active.value
}
</script>

<style scoped lang="scss">
@forward '@/styles/new_styles.scss';

.accordion-panel {
    border-radius: var(--border-radius-lg);
    min-height: 54px;

    &--ai-summary {
        background: linear-gradient(
            20deg,
            rgba(255, 255, 255, 1) 30%,
            rgba(242, 175, 58, 0.3) 100%
        );
        // background: green;

        .accordion-panel__header {
            border-left: 5px solid var(--color-gold);
            border-radius: 0 var(--border-radius-lg) var(--border-radius-lg) 0;
        }

        .accordion-panel__content {
            border-left: 5px solid;
            border-image: linear-gradient(to bottom, var(--color-gold), #8c6522) 0 0 0 1;
        }
    }

    &__header {
        cursor: pointer;
        border-radius: var(--border-radius-md);

        &--active {
            margin-bottom: var(--spacing-md);

            .accordion-panel__icon {
                transform: rotate(180deg);
            }
        }
    }

    &__title {
        &--accent {
            color: var(--accent);
        }
    }

    &__icon {
        transition: all 0.3s ease-in-out;
    }

    &__content {
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: all 0.3s ease-in-out;

        &--active {
            max-height: none;
            overflow: visible;
            opacity: 1;
        }
    }
}
</style>
